(function() { window.GUID_b3fb2bb8_2b94_4668_bb3a_3020bd4a12d1 = { getGuid: function() { return "b3fb2bb8-2b94-4668-bb3a-3020bd4a12d1"; } }; })();
var popupCreateOnTheFly;
var TeamName;
var TeamId;
var OperatorId;
var CustomValue1;
var CustomValue2;
var CustomValue3;
var DivnCustomValue1;
var DivnCustomValue2;
var DivnCustomValue3;
var SourceOfUpdate;
var ChangeTeamInfo;
CS.FormReady(function (formId) {
    if (formId == "AddTeamWithMembers") {
        BindAddTeamWithMembers($(this));
    }
    if (formId == "CreateOrUseExistingPlayerTeam") {
        CS.off('click', '.ExistingItemCard');
        CS.on('click', '.ExistingItemCard', function (e) {
            e.preventDefault();
            var clickedTarget = $(e.target);
            var card = clickedTarget.closest('.ExistingItemCard');
            if (clickedTarget.hasClass('BtnSelect') || clickedTarget.hasClass('Prop')) {
                popupCreateOnTheFly.Close();
                var data = CS.PrepareDataToSendGlobal(this);
                data.PersonId = card.data('id');
                data.TeamName = TeamName.val();
                data.TeamId = $('#teamid').val();
                data.OperatorId = OperatorId;
                data.CustomValue1 = CustomValue1;
                data.CustomValue2 = CustomValue2;
                data.CustomValue3 = CustomValue3;
                data.DivnCustomValue1 = DivnCustomValue1;
                data.DivnCustomValue2 = DivnCustomValue2;
                data.DivnCustomValue3 = DivnCustomValue3;
                data.SourceOfUpdate = SourceOfUpdate;
                data.ChangeTeamInfo = ChangeTeamInfo;
                importPlayerIntoTeam(data, TeamName);
            }
        });
    }
});
function BindAddTeamWithMembers(formContent) {
    var btnAddNewPlayer = $('#BtnAddNewPlayer');
    btnAddNewPlayer.off('click');
    btnAddNewPlayer.addClass('IsDisabled');
    var firstNameToAdd = $('#FirstNameToAdd');
    var lastNameToAdd = $('#LastNameToAdd');
    $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
    firstNameToAdd.on("keyup", function () {
        showOrHideAddButton();
    }).on('keydown', function (e) {
        var key = window.event ? e.keyCode : e.which;
        if (key == 13) {
            e.stopPropagation();
        }
    });
    lastNameToAdd.on("keyup", function () {
        showOrHideAddButton();
    }).on('keydown', function (e) {
        var key = window.event ? e.keyCode : e.which;
        if (key == 13) {
            e.stopPropagation();
            $('a', btnAddNewPlayer).trigger('click');
            firstNameToAdd.focus();
        }
    });
    function showOrHideAddButton() {
        if (lastNameToAdd.val() != "" && firstNameToAdd.val() != "") {
            btnAddNewPlayer.removeClass('IsDisabled');
        }
        else {
            btnAddNewPlayer.addClass('IsDisabled');
        }
    }
    btnAddNewPlayer.on('click', 'a', function (e) {
        e.preventDefault();
        var formAddTeamWithMembers = $('#AddTeamWithMembers');
        var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
        var data = CS.PrepareDataToSendGlobal(this);
        var firstName = "";
        var lastName = "";
        firstName = firstNameToAdd.val();
        lastName = lastNameToAdd.val();
        data.FirstNameToAdd = firstName;
        data.LastNameToAdd = lastName;
        data.TeamName = teamName.val();
        CompuSport.Ajax.Post(CSParameters.RUrl + "Teams/CheckIfExistsPlayer/" + CSParameters.SportEventId, data, function (queryResult) {
            if (queryResult.noEntityExist == true) {
                //AddPlayerOnTheFly(playertoadd, treeViewDivisions.SelectedValue());
                firstNameToAdd.val("");
                lastNameToAdd.val("");
                AddNewPlayer(firstName, lastName, function () {
                });
            }
            else {
                firstNameToAdd.val("");
                lastNameToAdd.val("");
                popupCreateOnTheFly = new CompuSport.Controls.Popup();
                var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
                //TeamName = teamName.val();
                TeamName = teamName;
                OperatorId = $('#ActualTeam_OperatorId').val();
                CustomValue1 = $('#ActualTeam_CustomValue1').val();
                CustomValue2 = $('#ActualTeam_CustomValue2').val();
                CustomValue3 = $('#ActualTeam_CustomValue3').val();
                DivnCustomValue1 = $('#ActualTeam_DivnCustomValue1').val();
                DivnCustomValue2 = $('#ActualTeam_DivnCustomValue2').val();
                DivnCustomValue3 = $('#ActualTeam_DivnCustomValue3').val();
                SourceOfUpdate = $('#SourceOfUpdate').val();
                ChangeTeamInfo = $('#ChangeTeamInfo').val();
                popupCreateOnTheFly.Show(queryResult.PlayerSelector, { PopupId: 'ExistingPlayer' });
                popupCreateOnTheFly.OnButtonClicked = function (button, buttonValue) {
                    if (buttonValue === 'Ok') {
                        AddNewPlayer(firstName, lastName, function () {
                            firstNameToAdd.val("");
                            lastNameToAdd.val("");
                            btnAddNewPlayer.addClass('IsDisabled');
                        });
                    }
                };
            }
        });
        /* AddNewPlayer(firstName, lastNameToAdd.val(), function () {
             firstNameToAdd.val("");
             lastNameToAdd.val("");
             btnAddNewPlayer.addClass('IsDisabled');
         });*/
    });
    var scanBox = $('#ScanBox');
    if (scanBox.length > 0) {
        scanBox.show();
        scanBox.CSScanBox();
        scanBox.on('scanned', function (e, value) {
            var data = {
                scanCode: value
            };
            var url = CSParameters.RUrl + "Persons/GetEntityIdFromScan/" + CSParameters.SportEventId;
            CompuSport.Ajax.Get(url, data, function (response) {
                var entityBaseId = response;
                if (entityBaseId != "") {
                    var formAddTeamWithMembers = $('#AddTeamWithMembers');
                    var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
                    var data = CS.PrepareDataToSendGlobal(this);
                    data.PersonId = entityBaseId;
                    data.teamid = $('#ActualTeam_Id').val();
                    data.TeamName = teamName.val();
                    data.OperatorId = $('#ActualTeam_OperatorId').val();
                    data.CustomValue1 = $('#ActualTeam_CustomValue1').val();
                    data.CustomValue2 = $('#ActualTeam_CustomValue2').val();
                    data.CustomValue3 = $('#ActualTeam_CustomValue3').val();
                    data.DivnCustomValue1 = $('#ActualTeam_DivnCustomValue1').val();
                    data.DivnCustomValue2 = $('#ActualTeam_DivnCustomValue2').val();
                    data.DivnCustomValue3 = $('#ActualTeam_DivnCustomValue3').val();
                    data.SourceOfUpdate = $('#SourceOfUpdate').val();
                    data.ChangeTeamInfo = $('#ChangeTeamInfo').val();
                    data.SelectedDivisionId = $('#SelectedDivisionId').val();
                    data.AssociationIds = $('#AssociationIds').val();
                    var autoRename = $('#AutoRenameTeamWithMember');
                    if (autoRename != null && autoRename.length > 0) {
                        data.AutoRenameTeamWithMember = autoRename[0].checked;
                    }
                    importPlayerIntoTeam(data, teamName);
                }
                else {
                    alert("Player not found");
                }
            });
        });
    }
    $('#ImportPersonId').on('AddedElementAtIndex0Click', function (e, ui) {
        var newName = ui.AutoComplete.val();
        if (newName == 'Search Here...') {
            return;
        }
        newName = newName.trim();
        var newNameSplitted = newName.split(' ');
        var end = newNameSplitted.length;
        var firstName = "";
        var lastName = "";
        for (var i = 0; i < end; i++) {
            if (i == 0) {
                firstName = newNameSplitted[i];
            }
            else {
                lastName += newNameSplitted[i] + ' ';
            }
        }
        firstName = firstName.trim();
        lastName = lastName.trim();
        if (lastName == "") {
            lastName = "_";
        }
        ui.ClearValue();
        var formAddTeamWithMembers = $('#AddTeamWithMembers');
        var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
        var data = CS.PrepareDataToSendGlobal(ui);
        data.FirstNameToAdd = firstName;
        data.LastNameToAdd = lastName;
        data.TeamName = teamName.val();
        CompuSport.Ajax.Post(CSParameters.RUrl + "Teams/CheckIfExistsPlayer/" + CSParameters.SportEventId, data, function (queryResult) {
            if (queryResult.noEntityExist == true) {
                //AddPlayerOnTheFly(playertoadd, treeViewDivisions.SelectedValue());
                AddNewPlayer(firstName, lastName, function () {
                });
            }
            else {
                popupCreateOnTheFly = new CompuSport.Controls.Popup();
                var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
                TeamName = teamName;
                OperatorId = $('#ActualTeam_OperatorId').val();
                CustomValue1 = $('#ActualTeam_CustomValue1').val();
                CustomValue2 = $('#ActualTeam_CustomValue2').val();
                CustomValue3 = $('#ActualTeam_CustomValue3').val();
                DivnCustomValue1 = $('#ActualTeam_DivnCustomValue1').val();
                DivnCustomValue2 = $('#ActualTeam_DivnCustomValue2').val();
                DivnCustomValue3 = $('#ActualTeam_DivnCustomValue3').val();
                SourceOfUpdate = $('#SourceOfUpdate').val();
                ChangeTeamInfo = $('#ChangeTeamInfo').val();
                popupCreateOnTheFly.Show(queryResult.PlayerSelector, { PopupId: 'ExistingPlayer' });
                popupCreateOnTheFly.OnButtonClicked = function (button, buttonValue) {
                    if (buttonValue === 'Ok') {
                        AddNewPlayer(firstName, lastName, function () {
                        });
                    }
                };
            }
        });
    });
    document.GridViewMemberOfTeamsPopup.Saved = function (e) {
        if (document.GridViewMemberOfTeams != undefined) {
            document.GridViewMemberOfTeams.RefreshGridData();
        }
    };
    document.GridViewMemberOfTeamsPopup.OverrideDeleteButton = function (e) {
        var me = this;
        CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.ConfirmDelete, function () {
            var data = CS.PrepareDataToSendGlobal(me);
            data.ids = me.GetSelectedRowIds();
            data.ByPassWarning = false;
            if (data.ids != "") {
                DeleteMemberOfTeam(me.DeleteUrl, data, me);
            }
        });
    };
    document.ImportPersonId.SelectionChange = function () {
        var autoComplete = this;
        if (this.SelectedItem != null) {
            var formAddTeamWithMembers = $('#AddTeamWithMembers');
            var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
            var data = CS.PrepareDataToSendGlobal(this);
            data.PersonId = this.val();
            data.TeamName = teamName.val();
            data.OperatorId = $('#ActualTeam_OperatorId').val();
            data.CustomValue1 = $('#ActualTeam_CustomValue1').val();
            data.CustomValue2 = $('#ActualTeam_CustomValue2').val();
            data.CustomValue3 = $('#ActualTeam_CustomValue3').val();
            data.DivnCustomValue1 = $('#ActualTeam_DivnCustomValue1').val();
            data.DivnCustomValue2 = $('#ActualTeam_DivnCustomValue2').val();
            data.DivnCustomValue3 = $('#ActualTeam_DivnCustomValue3').val();
            data.SourceOfUpdate = $('#SourceOfUpdate').val();
            data.ChangeTeamInfo = $('#ChangeTeamInfo').val();
            autoComplete.ClearValue();
            importPlayerIntoTeam(data, teamName);
        }
    };
    var actualForm = this;
    formContent.on('click', function (e) {
        var target = $(e.target);
        if (target.hasClass('PostButton')) {
            let gridViewPlayersPopupUI = $('#GridViewMemberOfTeamsPopup');
            let gridViewPlayersPopup = gridViewPlayersPopupUI.data('context');
            if (gridViewPlayersPopup.IsEdited) {
                gridViewPlayersPopup.SaveGrid();
                if (document.GridViewMemberOfTeams != undefined) {
                    document.GridViewMemberOfTeams.RefreshGridData();
                }
            }
        }
    });
}
function importPlayerIntoTeam(data, teamName) {
    CompuSport.Ajax.Post(CSParameters.RUrl + "Teams/ImportSelectedPerson/" + CSParameters.SportEventId, data, function (response) {
        if (response.success == true) {
            if (teamName != null && teamName != undefined) {
                teamName.val(response.teamname);
            }
            $('#ActualTeam_Id').val(response.teamid);
            $('#ActualTeam_Ids').val(response.teamid);
            $('#teamid').val(response.teamid);
            //$('#ActualTeam_CSEntityState').val('IsEdited');
            var selteamid = $('#SelectedTeamId');
            if (selteamid.length >= 1) {
                $('#SelectedTeamId').val(response.teamid);
                $('#SelectedTeamIdPopup').val(response.teamid);
            }
            if (response.rowsPlayer != null) {
                document.GridViewMemberOfTeamsPopup.UpdateRowsFromPost(response.rowsPlayer.Value);
                if (document.GridViewMemberOfTeams != undefined) {
                    document.GridViewMemberOfTeams.RefreshGridData();
                }
            }
        }
        else {
            alert(response.error);
        }
    });
}
let alreadyPosted = null;
function AddNewPlayer(firstName, lastName, callback) {
    if (alreadyPosted) {
        return;
    }
    alreadyPosted = true;
    var formAddTeamWithMembers = $('#AddTeamWithMembers');
    var teamName = $('#ActualTeam_Name', formAddTeamWithMembers);
    var data = CS.PrepareDataToSendGlobal(this);
    var autoRename = $('#AutoRenameTeamWithMember');
    data.PersonId = "";
    if (autoRename != null && autoRename.length > 0) {
        data.AutoRenameTeamWithMember = autoRename[0].checked;
    }
    data.SelectedDivisionId = $('#SelectedDivisionId').val();
    data.TeamName = teamName.val();
    data.teamid = $('#ActualTeam_Id').val();
    data.OperatorId = $('#ActualTeam_OperatorId').val();
    data.CustomValue1 = $('#ActualTeam_CustomValue1').val();
    data.CustomValue2 = $('#ActualTeam_CustomValue2').val();
    data.CustomValue3 = $('#ActualTeam_CustomValue3').val();
    data.DivnCustomValue1 = $('#ActualTeam_DivnCustomValue1').val();
    data.DivnCustomValue2 = $('#ActualTeam_DivnCustomValue2').val();
    data.DivnCustomValue3 = $('#ActualTeam_DivnCustomValue3').val();
    data.SourceOfUpdate = $('#SourceOfUpdate').val();
    data.FirstNameToAdd = firstName;
    data.LastNameToAdd = lastName;
    CompuSport.Ajax.Post(CSParameters.RUrl + "Teams/ImportSelectedPerson/" + CSParameters.SportEventId, data, function (response) {
        if (response.success != undefined && response.success == false) {
            CompuSport.Controls.Popup.ShowConfirmDialogV2('', response.error);
            //ShowConfirmDialog(response.message);
        }
        teamName.val(response.teamname);
        $('#ActualTeam_Id').val(response.teamid);
        $('#ActualTeam_Ids').val(response.teamid);
        //$('#ActualTeam_CSEntityState').val('IsEdited');
        $('#teamid').val(response.teamid);
        var selteamid = $('#SelectedTeamId');
        if (selteamid.length >= 1) {
            $('#SelectedTeamId').val(response.teamid);
            $('#SelectedTeamIdPopup').val(response.teamid);
        }
        if (response.rowsPlayer != null) {
            document.GridViewMemberOfTeamsPopup.UpdateRowsFromPost(response.rowsPlayer.Value);
            if (document.GridViewMemberOfTeams != undefined) {
                document.GridViewMemberOfTeams.RefreshGridData();
            }
        }
        callback.call(this);
        alreadyPosted = false;
    });
}
function DeleteMemberOfTeam(deleteUrl, newData, grid) {
    CompuSport.Ajax.Post(deleteUrl, newData, function (response) {
        if (response.HaveToAcceptWarnings == true) {
            CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.msgAvert, function () {
                newData.ByPassWarning = true;
                DeleteMemberOfTeam(deleteUrl, newData, grid);
            });
        }
        else {
            grid.UpdateRowsFromPost(response);
            //J'update la row du gridviewTeam ici
            var data = {};
            if (IsDefined(typeof $('#SelectedTeamIdPopup').val())) {
                data.SelectedTeamId = $('#SelectedTeamIdPopup').val();
            }
            else {
                data.SelectedTeamId = $('#SelectedTeamId').val();
            }
            data.SelectedDivisionId = $('#SelectedDivisionId').val();
            CompuSport.Ajax.Post(CSParameters.RUrl + "Teams/GetTeamRow/" + CSParameters.SportEventId, data, function (response) {
                if (document.GridViewTeams != undefined) {
                    document.GridViewTeams.UpdateRowsFromPost(response);
                    if (document.GridViewMemberOfTeams != undefined) {
                        document.GridViewMemberOfTeams.RefreshGridData();
                    }
                }
            });
        }
    });
}

//# sourceMappingURL=AddTeamsWithMember.js.map
